<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>منهج المشروع</h2>
        </div>
    </div>
</div>


<div class="service-details ptb-100">
    <div class="container">
      
        <div class="service-details-content">

            <div class="row">

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        تعرّف على القرآن الكريم

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/Kr9RCoMWph0?si=kxH5UqRSpFWl50VQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>


                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        النون والميم المشددتان | 1 (سلسلة أحكام التلاوة والتجويد)
                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/TcrnmAUgOF8?si=eV04BDz3xErPgTly" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        لإظهار الحلقي | 2 "أحكام النون الساكنة والتنوين" (سلسلة أحكام التلاوة والتجويد)
                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/Fkd0NIjUkQs?si=fDo6m3pzu8ElzY6I" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        الإدغام | 3 "أحكام النون الساكنة والتنوين" (سلسلة أحكام التلاوة والتجويد)
                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/pbDXg2kBYN8?si=xnR4tziijPjmWVXy" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>


                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        الإقلاب | 4 "أحكام النون الساكنة والتنوين" (سلسة أحكام التلاوة والتجويد )

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/5EhdiokFlbs?si=28DNFWOKW6cyMdPU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>



                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        الإخفاء | 5 "أحكام النون الساكنة والتنوين" (سلسة أحكام التلاوة والتجويد)


                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/RNXcTbJsWo4?si=-L0KX2Jgweut_ujW" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

                </div>





                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        الإخفاء الشفوي | 6 "أحكام الميم الساكنة" (سلسلة أحكام التلاوة والتجويد)

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/MeLqAU9iJpw?si=67hzPzxAUikKannb" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        الإدغام الشفوي والإظهار الشفوي | 7 "أحكام الميم الساكنة" (سلسلة أحكام التلاوة والتجويد)

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/oD4um5dc7Cw?si=AKxs6Q87dUpehgit" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        المد الطبيعي | 8 " أحكام المد" (سلسة أحكام التلاوة والتجويد)

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/gTWNPNT5Q0I?si=D0bQs8ptat08cyMQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        المد الواجب المتصل + المد الجائز المنفصل | 9 "أحكام المد" (سلسلة أحكام التلاوة)

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/fI28o9WhYxA?si=CFQj2CzWbGJez9u_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        المد اللازم | 10 "أحكام المد" (سلسلة أحكام التلاوة)

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/raRX4lLdJUg?si=gEK5GpRAPsSIqPE_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        المد العارض للسكون | 11 "أحكام المد" (سلسة أحكام التلاوة والتجويد)

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/7uteVyNYWZ8?si=2VbBW7G7U_3Nu8dy" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        مد الصلة "الصغرى والكبرى" | 12 "أحكام المد" (سلسة أحكام التلاوة والتجويد)

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/I-5nnBlMp0U?si=u4s5ir6pA_KqjKuy" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        التفخيم والترقيق (الجزء الأول) | 13 "(سلسة أحكام التلاوة والتجويد)

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/CBOiw1VdPWs?si=rBOIERlrDY6x-Mnn" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        التفخيم والترقيق (الجزء الثاني) | 14 | حالات الراء ، الألف ، اللام (سلسة أحكام التلاوة والتجويد)

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/OrkCPaAX-po?si=KJkFPPQEYmLFEZY8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        حكم القلقلة | 15 | (سلسة أحكام التلاوة والتجويد)

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/3rWxKRZ9Q0Y?si=WCvyC6syGmWMvRC8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        مراتب القلقة من حلقة 28 (الاتقان لتلاوة القران)


                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/cc_sc-Zp12I?si=HElUOuxvdpRfrkee" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12">
                    <h5>
                        اللحن الجلي واللحن الخفي

                    </h5>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/HiZf8DLW-KI?si=FWDPqZRd8-bN_UJN" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>









            </div>

            </div>
    </div>
</div>


